export const GET_GLOBAL_EVALUATIONS_REQUEST = "GET_GLOBAL_EVALUATIONS_REQUEST";
export const GET_GLOBAL_EVALUATIONS_REQUEST_SUCCEDED = "GET_GLOBAL_EVALUATIONS_REQUEST_SUCCEDED";
export const GET_GLOBAL_EVALUATIONS_REQUEST_FAILED = "GET_GLOBAL_EVALUATIONS_REQUEST_FAILED";
